import { Button, cn, Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@1trading/react';

// The report arrives as pre-rendered text lines from funds — display only, no parsing.
// Line colouring is a plain substring check (legacy parity): FAILED wins over PASSED.
const lineClassName = (line: string): string | undefined => {
  if (line.includes('FAILED')) return 'text-red-500';
  if (line.includes('PASSED')) return 'text-emerald-500';
  return undefined;
};

interface AmlReportDialogProps {
  report: string[];
  onClose: () => void;
}

export const AmlReportDialog = ({ report, onClose }: AmlReportDialogProps) => (
  <Dialog onOpenChange={(open) => (open ? undefined : onClose())} open>
    <DialogContent className="sm:max-w-[800px]">
      <DialogHeader>
        <DialogTitle>AML Report</DialogTitle>
      </DialogHeader>
      <div className="max-h-[70vh] overflow-y-auto">
        {report.map((line, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: display-only lines can repeat and never reorder
          <p className={cn('whitespace-pre-wrap font-mono text-xs leading-tight', lineClassName(line))} key={index}>
            {line}
          </p>
        ))}
      </div>
      <DialogFooter>
        <Button onClick={onClose} type="button">
          Close
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
AmlReportDialog.displayName = 'AmlReportDialog';
